/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PlatformFee/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PlatformFee({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/IsAcknowledged/AcknowledgementText/PlatformFee"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let providerAccountCardFeePercentValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'card_fee_percent',
})
let providerAccountAchFeePercentValueData = fromData.useDataValue({ viewPath,
context: 'provider_account',
path: 'ach_fee_percent',
})
let aggregateData = fromHelpers.getText(providerAccountCardFeePercentValueData, providerAccountAchFeePercentValueData)
let constantData = 'I acknowledge that enabling the platform fee requires notifying all responsible parties, including those with existing payments who may not have agreed to this fee in their original terms. I also acknowledge that'
let globalCurrentLocationParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'global',
path: 'current_location.parent_company.name',
})
let constantData1 = 'has confirmed appropriate communication has been, or will be, provided to address this change.'
let aggregateData1 = fromAggregate.join(constantData, globalCurrentLocationParentCompanyNameValueData, constantData1)
  return (<React.Fragment
>
<div
  data-testid="PlatformFee.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z1CjvsU': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 data="provider_account.card_fee_percent"
 data="provider_account.ach_fee_percent"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
<TysiaCheckboxText
  viewPath={`${viewPath}/TysiaCheckboxText`}
 data="'I acknowledge that enabling the platform fee requires notifying all responsible parties, including those with existing payments who may not have agreed to this fee in their original terms. I also acknowledge that'"
 data="global.current_location.parent_company.name"
 data="'has confirmed appropriate communication has been, or will be, provided to address this change.'"
 aggregate="/Data/aggregate.js join"
 text={aggregateData1}
/>
</div>
{children}
</React.Fragment>)
}